import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=a451e4a8&scoped=true&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=a451e4a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a451e4a8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogForm: require('/builds/knockmedia/knock-vi-web/src/components/BlogForm.vue').default})
